import React from 'react';
import { i18n } from 'next-i18next';
import { ThemeProvider, fontFamilies } from '@sy/component-library';
import WrapWithProviders from '@sy/app-client/src/ssrAdapter/ssrWrapper';
import Footer from '@sy/app-client/src/ssrAdapter/components/Footer';
import LandingHeader from '@sy/app-client/src/ssrAdapter/components/LandingHeader';
import type { CacheNavigation } from '@sy/ssr-types';

import type { FeatureFlags } from '~/getServerSideProps/contextDecorators/withFeatureFlags';

import { Layout, Top, TopPadding } from './MarketingTemplate.styles';
import WithGoogleOneTap from './WithGoogleOneTap';

const MarketingTemplate = ({
	activePage,
	children,
	navigation,
	overflowVisible,
	topPadding = true,
	user,
	logoVersion = 'control',
	isLogoExperimentVariant = false,
}: Props) => (
	<WrapWithProviders i18n={i18n} user={user} withTheme={false}>
		<ThemeProvider
			themeName={isLogoExperimentVariant ? 'dark' : 'marketing'}
			isGlobal
			isCustom={isLogoExperimentVariant}
			fontFamily={isLogoExperimentVariant ? fontFamilies.satoshi : undefined}
		>
			<>
				<WithGoogleOneTap />
				<Layout
					overflowVisible={overflowVisible}
					isLogoExperimentVariant={isLogoExperimentVariant}
				>
					<Top>
						<LandingHeader
							activePage={activePage}
							header={navigation?.header}
							isLogoExperimentVariant={isLogoExperimentVariant}
							logoVersion={logoVersion}
						/>
						{topPadding && !isLogoExperimentVariant && <TopPadding />}
						{children}
					</Top>
				</Layout>
				<Footer logoVersion={logoVersion} />
			</>
		</ThemeProvider>
	</WrapWithProviders>
);

interface Props {
	activePage?: string;
	children: React.ReactNode;
	featureFlags: FeatureFlags;
	overflowVisible?: boolean;
	navigation?: CacheNavigation | null;
	topPadding?: boolean;
	user: { email: string | null; id: string | null };
	logoVersion?: 'control' | 'treatment1' | 'treatment2';
	isLogoExperimentVariant?: boolean;
}

export default MarketingTemplate;
